<template>
  <material-card
    color="dover-blue">
    <div>
      <v-flex
        xs12
        md12>
        <material-card
          v-bind="{ title: getTitle(), text: getText() }"
          :key="componentKey"
          color="dover-blue">
          <div>
            <v-flex
              xs12
              md12>
              <v-tabs
                fixed-tabs
                color="dover-blue"
                slider-color="yellow"
                dark
                icons-and-text>
                <v-tab
                  :key="0"
                  ripple>
                  {{ $t('Settings') }}
                  <v-icon>mdi-settings</v-icon>
                </v-tab>
                <v-tab-item
                  :key="0">
                  <MaglinkSensorSettings
                    :is-new-sensor="isNewSensor"
                    :options="options"
                    :sensor="sensor"
                    :sensors="sensors"
                    :sensor-types="sensorTypes"
                    :site-info="siteInfo"
                    :system-settings="systemSettings" />
                </v-tab-item>
                <v-tab
                  :key="1"
                  ripple>
                  {{ $t('Relays') }}
                  <v-icon>mdi-chip</v-icon>
                </v-tab>
                <v-tab-item
                  :key="1">
                  <MaglinkSensorRelaysSettings
                    :options="options"
                    :relays="sensor.relays"
                    :site-info="siteInfo"
                    :is-plus="isPlus"/>
                </v-tab-item>
              </v-tabs>
            </v-flex>
          </div>
          <v-container>
            <v-layout justify-row-center>
              <MaglinkComponentDialogYesNo
                :key="dialogYN.key"
                :component-key="dialogYN.componentKey"
                :dialog="dialogYN.show"
                :title="dialogYN.title"
                :label-text="dialogYN.labelText"
                :custom-par1="dialogYN.action"
                :custom-par2="dialogYN.result"
                :custom-par3="dialogYN.sensor"
                @dialogResultYesNo="onDialogResult"/>
              <v-flex
                xs12
                md12
                lg12
                text-xs-center>
                <v-btn
                  :disabled="sensor.sensorNumber === 0"
                  small
                  class="mx-0 font-weight-light"
                  color="dover-blue"
                  @click="onSave()">
                  {{ $t('Save') }}
                </v-btn>
              </v-flex>
              <v-flex
                xs12
                md12
                lg12
                text-xs-center>
                <v-btn
                  :disabled="isNewSensor"
                  small
                  class="mx-0 font-weight-light"
                  color="dover-red"
                  @click="onDelete()">
                  {{ $t('Delete') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </material-card>
      </v-flex>
    </div>
  </material-card>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  props: {
    isNewSensor: {
      type: Boolean,
      require: true,
      default: () => false
    },
    sensor: {
      type: Object,
      required: false,
      default: () => {}
    },
    sensors: {
      type: Object,
      required: false,
      default: () => {}
    },
    siteInfo: {
      type: Object,
      required: true,
      default: () => {}
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    },
    componentKey: {
      type: Number,
      required: true,
      default: () => 0
    },
    isPlus: {
      type: Boolean,
      required: true,
      default: () => false
    }
  },
  data: () => ({
    keepShowing: false,
    baseSensorTemplate: {
      associationAddress: 1,
      associationType: 0, // tank,sump,site
      contact: true,
      enabled: true,
      internal: false,
      lastAlarm: {
        ackStatus: 0,
        id: 0,
        measuredOn: 0,
        sensorNumber: 0,
        sensorStatus: 0,
        sensorValue: 0
      },
      physicalChannels: [],
      readingChannels: [],
      relays: [],
      sensorModel: '', // not used
      sensorName: i18n.t('New Sensor'),
      sensorNumber: 0,
      sensorType: 0, // on/off sensor
      serial: '',
      thresholds: []
    },
    sensorTypes: [],
    dialogYN: {
      key: 0,
      show: false,
      componentKey: '',
      title: '',
      labelText: '',
      action: '',
      result: '',
      sensor: undefined
    }
  }),
  mounted () {
    this.setSensorTypes()
  },
  methods: {
    setSensorTypes () {
      this.sensorTypes = this.Maglink.SensorTypesBasic()
      if (this.isPlus) {
        this.sensorTypes = this.sensorTypes.concat(this.Maglink.SensorTypesPlus())
      }
    },
    checkBeforeSave (item) {
      item.sensorNumber = item.sensorNumber * 1

      for (let devIndex = 0; devIndex < this.maxDevices; devIndex++) {
        if (item.relays[devIndex].relayIndex > 4) {
          item.relays[devIndex].internal = false
          item.relays[devIndex].relayNumber = item.relays[devIndex].relayIndex - 4
        } else {
          item.relays[devIndex].internal = true
          item.relays[devIndex].relayNumber = item.relays[devIndex].relayIndex
        }
      }

      if (item.physicalChannels[0].type === 0) {
        if (item.sensorType < 2) {
          this.setPhysicalChannelsType(item, 32)
        } else if (item.sensorType > 3) {
          this.setPhysicalChannelsType(item, 78)
        } else {
          this.setPhysicalChannelsType(item, 7)
        }
      }

      item.physicalChannels.forEach(channel => {
        channel.normalClosed = item.physicalChannels[0].normalClosed
      })

      if (item.sensorType === 1 && item.physicalChannels[0].address === item.physicalChannels[1].address) {
        return this.$t('Sensor uses same position for both channels')
      }

      for (let i = 0; i < this.sensors.length; i++) {
        if (item.sensorType > 1) {
          break
        }
        if (item.sensorNumber === this.sensors[i].sensorNumber || this.sensors[i].sensorType > 1) {
          continue
        }

        for (let itemCh = 0; itemCh < (item.sensorType === 0 ? 1 : 2); itemCh++) {
          for (let sCh = 0; sCh < (this.sensors[i].sensorType === 0 ? 1 : 2); sCh++) {
            if (item.physicalChannels[0].device === this.sensors[i].physicalChannels[0].device && item.physicalChannels[itemCh].address === this.sensors[i].physicalChannels[sCh].address) {
              return this.$t(`Sensor {0} already uses position {1}`, [ this.sensors[i].sensorNumber, item.physicalChannels[itemCh].address ])
            }
          }
        }
      }
      return ''
    },
    setPhysicalChannelsType (item, value) {
      item.physicalChannels.forEach(channel => {
        channel.type = value
      })
    },
    /*
    checkUniquePosition (item) {
      let sensorNumber = item.sensorNumber
      for (let devIndex = 0; devIndex < this.maxDevices; devIndex++) {
        let sensorCategory = item.physicalChannels[devIndex].device
        let sensorPosition = item.physicalChannels[devIndex].address

        this.snackbarPosition = false

        // check for unique position
        for (let index = 0; index < this.sensors.length; index++) {
          let sensor = this.sensors[index]

          // check for same category
          if (sensor.physicalChannels[devIndex].device !== sensorCategory) { continue }

          for (let innerDevIndex = 0; innerDevIndex < this.maxDevices; innerDevIndex++) {
            // skip current item and current device
            if (sensor.sensorNumber === sensorNumber && innerDevIndex === devIndex) { continue }

            // different position
            if (sensor.physicalChannels[innerDevIndex].address !== sensorPosition) { continue }

            this.msgPositionAlreadyInUse = this.$t('Sensor "{0}" already uses position "{1}"', [ sensor.sensorNumber, sensorPosition ])
            this.snackbarPosition = true

            break
          }

          if (this.snackbarPosition) { break }
        }

        // check for unique position in other sensor type
        for (let index = 0; index < this.otherSensors.length; index++) {
          let sensor = this.otherSensors[index]

          // esclude wireless sensor from check
          if (sensor.sensorType < 2 || sensor.sensorType > 3) { continue }
          // check for same category: internal or I/O box
          if (sensor.physicalChannels[devIndex].device !== sensorCategory) { continue }

          // must check sensortype to know max humber of devices
          let maxDevices = item.sensorType === 0 ? 1 : 2

          for (let innerDevIndex = 0; innerDevIndex < maxDevices; innerDevIndex++) {
            // different position
            if (sensor.physicalChannels[innerDevIndex].address !== sensorPosition) { continue }

            let sensorTypeDesc = ''
            if (sensor.sensorType === 0) {
              sensorTypeDesc = this.$t('On/Off sensor').toUpperCase()
            } else if (sensor.sensorType === 1) {
              sensorTypeDesc = this.$t('Discriminating sensor').toUpperCase()
            }

            this.msgPositionAlreadyInUse = this.$t('Sensor "{0}" already uses position "{1}" ({2})', [ sensor.sensorNumber, sensorPosition, sensorTypeDesc ])
            this.snackbarPosition = true

            break
          }

          if (this.snackbarPosition) { break }
        }
      }

      return !this.snackbarPosition
    },
    */
    onDelete () {
      this.dialogYN.title = this.$t('Warning').toUpperCase()
      this.dialogYN.labelText = '\n\n' + this.$t('You are about to DELETE selected sensor: {0}', [ this.sensor.sensorName ]) + '\n\n' + this.$t('Are you sure?')
      this.dialogYN.componentKey = 'delete'
      this.dialogYN.action = 'delete'
      this.dialogYN.result = this.sensor.sensorNumber.toString()
      this.dialogYN.sensor = this.sensor
      this.dialogYN.show = true
    },
    onDialogResult (componentKey, result, action, par2, item) {
      this.dialogYN.show = false

      // NO button pressed
      if (!result) return

      // convert to number
      let id = item.sensorNumber * 1
      this.Maglink.DeleteSensor(id)
        .then(response => {
          this.snack('success', this.$t('Sensor "{0}" deleted successfully', [ item.sensorName ]))
          this.$emit('sensorDeleted', this.sensor)
        })
        .catch(error => (this.snack('error', error.message)))
    },
    onSave () {
      let checkMessage = this.checkBeforeSave(this.sensor)
      if (checkMessage !== '') {
        this.snack('error', checkMessage)
        return
      }

      this.isSensorValidated = true

      this.Maglink.SaveSensor(this.sensor)
        .then(response => {
          this.snack('success', this.$t('Sensor "{0}" saved successfully', [ this.sensor.sensorName ]))
          this.$emit('sensorSaved', this.sensor)
          if (this.isNewSensor) {
            this.resetSensor()
          }
        })
        .catch(error => (this.snack('error', error.message)))
    },
    getText () {
      if (this.sensor === undefined) {
        this.resetSensor()
      }

      let result = this.sensor.sensorName
      if (result === undefined) {
        result = this.$t('Sensor {0}', [this.sensor.sensorNumber])
      }

      return result
    },
    getTitle () {
      if (this.sensor === undefined) {
        this.resetSensor()
      }

      let type = this.sensor.sensorType
      if (type === undefined) {
        return this.sensorTypes[0].desc
      }

      let result = ''
      for (let index = 0; index < this.sensorTypes.length; index++) {
        let sensorType = this.sensorTypes[index]

        if (sensorType.code === type) {
          result = sensorType.desc
          break
        }
      }

      return result
    },
    resetSensor () {
      let baseSensor = Object.assign({}, this.baseSensorTemplate)

      // add Physical channels
      for (let i = 1; i < 3; i++) {
        baseSensor.physicalChannels.push({ id: i, address: i, device: i, normalClosed: false, type: 0 })
      }

      // add Reading channels
      for (let i = 1; i < 3; i++) {
        baseSensor.readingChannels.push({ id: i, status: 1, value: 1 })
      }

      // add Relays
      for (let i = 1; i < 5; i++) {
        baseSensor.relays.push({ id: i, relayNumber: i, internal: true, triggerStatus: 0 })
      }
      for (let i = 1; i < 33; i++) {
        baseSensor.relays.push({ id: i + 4, relayNumber: i, internal: false, triggerStatus: 0 })
      }

      // add Thresholds
      for (let i = 1; i < 3; i++) {
        baseSensor.thresholds.push({ id: i, value: 0.0 })
      }

      this.sensor = baseSensor
    },
    snack (color, message) {
      message = this.$t('Sensors setup') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
